module.exports = __webpack_public_path__ + "static/media/preview.e0cb1b1c.png";